import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import api from '../request'; // axios instance
import { Link } from 'react-router-dom';
import '../index.css';
import ErrorMessage from '../components/ErrorMessage';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const res = await api.post('/forgot-password', { email });
      setSuccessMsg(res.data.message);
    } catch (error) {
      setErrorMsg(
        error.response?.data?.message || 'Failed to send reset link. Try again.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-light">
      <header className="py-4 px-6 flex justify-center">
        <h1 className="text-2xl font-bold text-primary">
          Stepping<span className="text-secondary">4</span>Life
        </h1>
      </header>

      <main className="flex-1 flex justify-center items-center px-6">
        <div className="w-full max-w-md">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-text-primary">Forgot Password</h2>
            <p className="text-text-secondary mt-2">
              Enter your email to receive a password reset link.
            </p>
          </div>

          {errorMsg && <ErrorMessage message={errorMsg} />}
          {successMsg && <div className="text-green-600 text-sm mb-4">{successMsg}</div>}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-text-primary mb-1">
                Email
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail size={18} className="text-gray-400" />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="name@example.com"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="text-center mt-6">
            <Link to="/login" className="text-sm text-secondary hover:text-primary">
              Back to Login
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;
